import React, { useState } from "react";
import RecurringSummaryCancelModal from "./RecurringSummaryCancelModal";

/**
 * @param {object} props
 * @param {Function} props.onClose
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryCancelModal = ({ onClose }) => {
    const [loading, setLoading] = useState(false);
    const recurringSummaryCancelModalProps = {
        loading,
        onClose,
        setLoading,
    };
    return (
        <RecurringSummaryCancelModal {...recurringSummaryCancelModalProps} />
    );
};

export default ConnectedRecurringSummaryCancelModal;
